import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {

  private message = {
    FEEDBACK_CAPTURED: 'Captured Successfully..',
    FEEDBACK_RETRY: 'Something is weird, move slightly to change lighting',
    FEEDBACK_VIDEO_CHALLENGE: "Read text out aloud",
    FEEDBACK_RETRY_INSECURE: 'Insecure camera feed.',
    FEEDBACK_RETRY_QUALITY: 'Bad Quality, Retry Capture',
    FEEDBACK_CAPTURE_TIMEOUT: 'No Face found, Retry?',
    FEEDBACK_CAMERA_ACQUIRING_FAILED: 'Cannot acquire camera, Allow permission Or Retry Capture',
    FEEDBACK_ORIENTATION_NOT_SUPPORTED: 'Only Portrait mode is supported',
    FEEDBACK_TRAINING_DIALOG_CLOSED: 'Training dialog, exited',
    FEEDBACK_LICENCE_INVALID: 'License Invalid!!',
    ERROR_NO_INPUT_DEVICES: 'No video input devices.',
    ERROR_REQUEST_EXPIRED: 'Request Expired...',
    ERROR_BROWSER_NOT_SUPPORTED: 'Browser not supported. Please use Chrome, Opera, Edge(iOS, Android, Desktop), Samsung Internet (Android) or Safari (iOS, MAC)',
    ERROR_BROWSER_VERSION_NOT_SUPPORTED: 'Browser version not supported. Please update to latest version available.',
    ERROR_BROWSER_FEATURE_NOT_SUPPORTED: "TextDecoder or Crypto API not present.",
    ERROR_DEVICE_NOT_SUPPORTED: 'Device not supported, Please use mobile device or desktop.',
    ERROR_DEVICE_NOT_SUPPORTED_ANDROID: "Android version not supported. Please update to latest version available",
    ERROR_DEVICE_NOT_SUPPORTED_IOS: "IOS version not supported. Please update to latest version available",
    ERROR_DEVICE_NOT_SUPPORTED_MEMORY: "Device not supported. Insufficient Memory",
    ERROR_PLATFORM_NOT_SUPPORTED_ANDROID: "Android version not supported. Please update to latest version available",
    ERROR_PLATFORM_NOT_SUPPORTED_IOS: "IOS version not supported for this browser. Please update to latest version available",
    ERROR_WEBRTC_NOT_SUPPORTED: 'Webrtc not supported',
    ERROR_SERVER_CONNECTION_FAILURE: 'Server connection failure',
    FEEDBACK_VIDEO_CHALLENGE_STOP: "Stop"
  }
  constructor() { }

  getErrorString(feedback: string) {
      return this.message[feedback];
  }
}
